import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import FormAppResource from "./FormAppResource";

export const LICENSED = 11010;
export const NOT_LICENSED = 11020;
export const IN_PROGRESS = 11030;
export const NOT_AVAILABLE = 11040;

export const ALL = {
    LICENSED,
    NOT_LICENSED,
    IN_PROGRESS,
    NOT_AVAILABLE,
};

class LuFormLicenceStatusAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'lu-form-licence-status';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'lus/forms/licences/statuses';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'slug',
            'title',
            'description',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            forms: FormAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            slug: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            title: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            description: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
        };
    }


}

export default LuFormLicenceStatusAppResource;
